<template>
  <layout-default
    :hide-footer-mobile="true"
    :class="{ 'bg-purple': bgColorPurple }"
    :show-backpack="false"
  >
    <div class="academia-egresados-inscription">
      <div class="container h-100">
        <div class="main-content h-100 d-flex flex-wrap align-items-center">
          <div class="w-100">
            <div class="row no-gutters">
              <div class="col-md-6 d-none d-md-block">
                <img src="/images/0000.png" alt="" />
              </div>

              <div class="col-md-6 d-flex align-items-md-center">
                <div class="main-content-text">
                  <p>SÓLO INSCRIBIÉNDOTE ONLINE</p>
                  <h3>
                    {{ discount }}% DESCUENTO <br />
                  </h3>

                  <div class="pdv-form-group mt-3">
                    <!--Form inscription-->

                    <form
                      id="programInscription"
                      @submit.prevent="ifFormValid($event, submit)"
                    >
                      <div class="row custom-pdv-row">
                        <div class="col-md-6 custom-pdv-col">
                          <div class="form-group">
                            <label for="inscriptionName">Nombre</label>
                            <input
                              type="text"
                              id="inscriptionName"
                              v-model="formStudent.name"
                              name="nombre"
                              onkeypress="return /[a-zA-ZáéíóúÁÉÍÓÚ ]/i.test(event.key)"
                              maxlength="30"
                            />
                          </div>
                        </div>

                        <div class="col-md-6 col-7 custom-pdv-col">
                          <div class="form-group">
                            <label for="">Apellido Paterno</label>
                            <input
                              type="text"
                              id=""
                              v-model="formStudent.fatherLastName"
                              name="apellidoPaterno"
                              maxlength="15"
                              onkeypress="return /[a-zA-ZáéíóúÁÉÍÓÚ ]/i.test(event.key)"
                            />
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-4 col-6">
                          <div class="form-group">
                            <label for="">RUT</label>
                            <vue-mask
                              mask="00.000.000-K"
                              :raw="false"
                              :options="{
                                reverse: true,
                                translation: { K: { pattern: /[0-9kK]/ } }
                              }"
                              v-model="formStudent.rut"
                              id=""
                              name="rut"
                            ></vue-mask>
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-8">
                          <div class="form-group">
                            <label for="">Email</label>
                            <input
                              type="email"
                              v-model="formStudent.email"
                              id=""
                              name="email"
                              maxlength="50"
                            />
                          </div>
                        </div>
                      </div>

                      <div class="pdv-submit-button">
                        <div class="row">
                          <div class="col-md-5">
                            <div class="form-group">
                              <button
                                type="submit"
                                @submit.prevent="submit"
                                class="btn-pdv-primary"
                              >
                                COTIZA Y MATRICÚLATE
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </layout-default>
</template>

<script>
import LayoutDefault from '@/layouts/Default';
import formValidation from '@/mixins/formValidation';
import recaptchaVisibility from '@/mixins/recaptchaVisibility';
import vueMask from 'vue-jquery-mask';
import Cookies from 'js-cookie';

export default {
  data() {
    return {
      createdStudent: null,

      bgColorPurple: true,

      captchaSiteKey: process.env.VUE_APP_CAPTCHA_SITE_KEY,

      discount: null
    };
  },

  computed: {
    formStudent() {
      return {
        name: this.$store.getters.lastStudent.name || null,
        fatherLastName: this.$store.getters.lastStudent.fatherLastName || null,
        lastName: this.$store.getters.lastStudent.lastName || null,
        rut: this.$store.getters.lastStudent.rut || null,
        email: this.$store.getters.lastStudent.email || null
      };
    },
    students() {
      return this.$store.state.students;
    }
  },

  components: {
    LayoutDefault,
    vueMask
  },

  mixins: [formValidation, recaptchaVisibility],

  methods: {
    async submit() {
      await this.$recaptchaLoaded();
      const token = await this.$recaptcha('registerStudent');
      if (token) {
        const result = await this.Axios.post('/verify-recaptcha', {
          recaptchaToken: token
        });
        if (result.data.success) {
          this.saveFormInfo();
        }
      }
    },
    async saveFormInfo() {
      this.formStudent.lastName = `${this.formStudent.fatherLastName}`;
      const res = await this.createStudent();
      await this.$store.dispatch('addStudent', {
        ...res.data,
        fatherLastName: this.formStudent.fatherLastName
      });
      let sessionState = {
        students: this.students
      };
      await this.$store.dispatch('addInfoToFullOrder', {
        sessionState: JSON.stringify(sessionState)
      });
      const { data: order } = await this.Axios.post('/orders', {
        ...this.$store.state.fullOrder,
        initialStudentId: this.students[0].id
      });
      Cookies.set('sessionId', order.sessionId);
      this.goToNextStep();
    },

    goToNextStep() {
      this.$router.push({ name: 'Step1' });
    },

    createStudent() {
      return new Promise((resolve, reject) => {
        this.Axios.post('/students', this.formStudent)
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            if (error.response.status === 400) {
              console.log(error.response);
              if (
                error.response.data.message ===
                'Error - Email address already in use!'
              ) {
                alert(
                  'El correo: ' +
                    error.response.data.problemField.email +
                    ' ya se encuentra registrado'
                );
              }
            }
            reject(error);
          });
      });
    }
  },

  mounted() {
    this.validateForm(
      $('#programInscription'),
      {
        nombre: {
          required: true,
          lettersonly: true
        },

        apellidoPaterno: {
          required: true,
          lettersonly: true
        },

        apellidoMaterno: {
          required: true,
          lettersonly: true
        },

        rut: {
          required: true,
          rut: true
        },

        email: {
          minlength: 8,
          required: true,
          email: function( value, element ) {
            // return /^([a-zA-Z0-9]+(?:[.-]?[a-zA-Z0-9]+)@[a-zA-Z0-9]+(?:[.-]?[a-zA-Z0-9]+)\.[a-zA-Z]{2,7})$/.test( value );
            return /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/.test(value)
          }
        }
      },

      {
        apellidoPaterno: {
          required: 'Debes ingresar tu apellido paterno',
          lettersonly: 'Solo se permiten letras'
        },

        apellidoMaterno: {
          required: 'Debes ingresar tu apellido materno',
          lettersonly: 'Solo se permiten letras'
        },

        nombre: {
          required: 'Ingresa tu nombre',
          lettersonly: 'Solo se permiten letras'
        },

        rut: {
          required: 'Debes ingresar el RUT',
          rut: 'El RUT ingresado no es válido'
        },

        email: {
          minlength: 'Debes ingresar un correo valido',
          required: 'Debes ingresar un correo',
          email: 'Debes ingresar un correo valido'
        }
      }
    );
  },
  created(){
  this.Axios.get('/dashadmin/infogeneral').then((response) => {
      this.discount= response.data[0].discount;

    });
}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.academia-egresados-inscription {
  padding-top: 120px;
  position: relative;
  height: 850px;
  background: $yellow;
  @include media-breakpoint-down(sm) {
    height: auto;
    padding-bottom: 125px;
  }
  .logo {
    padding: 10px 34px;
  }

  .main-content {
    img {
      width: 600px;
      position: absolute;
      bottom: 0;
      left: 0;
    }

    .main-content-text {
      p {
        letter-spacing: 4px;
        line-height: 19px;
        margin-bottom: 0;
        @include font-medium-regular;
        color: #000;
        @include media-breakpoint-down(sm) {
          font-size: 14px;
          line-height: 18px;
          margin-bottom: 20px;
        }
      }
      h3 {
        color: #000;
        font-size: 35px;
        line-height: 38px;
        margin-bottom: 0;
        @include font-extra-bold-regular;
        @include media-breakpoint-down(sm) {
          font-size: 25px;
          line-height: 25px;
        }
      }
    }
  }
}

.pdv-submit-button {
  button {
    background: #ffffff;
    box-shadow: none;
  }
  .form-group {
    margin-bottom: 0;
  }
  @include media-breakpoint-down(sm) {
    position: fixed;
    width: 100%;
    padding: 23px 16px;
    box-shadow: 0 -2px 6px 0 rgba(0, 0, 0, 0.1);
    bottom: 0;
    left: 0;
    z-index: 99;
    background: #000;
  }
}
</style>
